import { Button } from "~/components/ui";

const SummaryStep = ({ watch }: any) => {
  const data = watch();

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-primary-500">Review Summary</h3>

      <div className="rounded-lg border border-neutral-200 p-6 space-y-4 text-sm">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-neutral-500">Title</p>
            <p className="font-medium">{data.title || "-"}</p>
          </div>
          <div>
            <p className="text-neutral-500">Permit Type</p>
            <p className="font-medium">{data.permitType || "-"}</p>
          </div>
          <div>
            <p className="text-neutral-500">Location</p>
            <p className="font-medium">{data.location || "-"}</p>
          </div>
          <div>
            <p className="text-neutral-500">JSA Reference</p>
            <p className="font-medium">{data.jsaId?.label || "-"}</p>
          </div>
        </div>
      </div>

      <div className="flex justify-end">
        <Button type="submit" variant="default">
          Submit Permit to Work
        </Button>
      </div>
    </div>
  );
};

export default SummaryStep;
